import { IRootState } from '..';

export const SELECTOR_MARKER_MARKERS = (state: IRootState) => state.Marker.markers;
export const SELECTOR_MARKER_CURRENT_MARKER = (state: IRootState) => state.Marker.currentMarker;
export const SELECTOR_MARKER_STATUS = (state: IRootState) => state.Marker.status;
export const SELECTOR_MARKER_SELECTED_MARKER_ID = (state: IRootState) => state.Marker.selectedMarkerId;
export const SELECTOR_MARKER_IS_MARKER_OVERLAY_VISIBLE = (state: IRootState) => state.Marker.isMarkerOverlayVisible;
export const SELECTOR_MARKER_IS_MARKER_PREVIEW_ENABLED = (state: IRootState) => state.Marker.isMarkerPreviewEnabled;
